import { useId as o, useMemo as d } from "react";
const t = (s) => {
  const e = o();
  return d(() => s ? `${s}-${e}` : e, [s, e]);
}, r = (s) => t(s);
export {
  t as useId,
  r as useNamedId
};
